import MediaUploadBase from 'admin/editor/components/media_upload_base';
import ImagesLoaded from 'imagesloaded';

export default class MediaUploadElement extends MediaUploadBase {
  baseUrl() {
    return '/pages/' + this.learnEditor.pageID + '/assets/';
  }

  editUrl(asset) {
    return this.baseUrl() + asset + '/edit_image';
  }

  shouldShowButton() {
    return $('input[name="page_type"]').val() !== 'user';
  }
}
